import { CaseManagement } from "../model/caseMan/CaseManagement";

export class CaseManPostCommand{
    Message: CaseManagement;

    constructor(message: CaseManagement){
        this.Message = message;
    }
}